import { Loader } from './loader';

export const Form = async (props, container, append = null) => {
    const {
        form_id,
        chili_piper_enabled = false, 
        chili_piper_router = '', 
        redirect_completion_enabled = false, 
        redirect_completion_url = 'http://www.shipbob.com/thank-you/',
    } = props;

    const query = `card-body form-${form_id}`;
    const element = document.createElement('div');
    element.setAttribute('class', query);
    element.setAttribute('data-controller', 'form-controller');
    element.setAttribute('data-form-controller-form-id-value', form_id);
    element.setAttribute('data-form-controller-form-container-query-value', query);
    element.setAttribute('data-form-controller-chili-piper-enabled-value', chili_piper_enabled);
    element.setAttribute('data-form-controller-router-value', chili_piper_router);
    element.setAttribute('data-form-controller-redirect-completion-enabled-value', redirect_completion_enabled);
    element.setAttribute('data-form-controller-redirect-completion-url-value', redirect_completion_url);
    element.innerHTML = Loader();

    if (append) {
        container.appendChild(element);
        container.innerHTML += append;
    } else {
        container.appendChild(element);
    }
}

export const StepForm = (props, container, append = false) => {
    const Dom = (props) => (`
        <div 
            class='form-step-controller' 
            data-controller='form-step-controller' 
            data-form-step-controller-props-value='${JSON.stringify(props)}' 
            data-action='form-ready-${props.form_id}@window->form-step-controller#initSteps hs-input-validation-response-${props.form_id}@window->form-step-controller#validationResponse'
        >
            <div class="form-step-controller-steps" data-form-step-controller-target="formSteps"></div>
            <button data-action='click->form-step-controller#close' class='form-step-controller-close'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#F8F8FC"></rect><path d="M7.15915 7.92861C7.23852 8.00798 7.31789 8.08734 7.39834 8.1678C7.6147 8.38415 7.83214 8.6016 8.0485 8.81795C8.36814 9.1376 8.6867 9.45615 9.00634 9.77579C9.39556 10.165 9.78479 10.5542 10.1751 10.9446C10.6024 11.3718 11.0307 11.8002 11.458 12.2275C11.8896 12.6591 12.3213 13.0907 12.754 13.5234C13.1552 13.9246 13.5564 14.3258 13.9586 14.7281C14.2978 15.0673 14.6371 15.4065 14.9763 15.7457C15.2209 15.9903 15.4655 16.235 15.7101 16.4796C15.8254 16.5948 15.9406 16.7112 16.057 16.8264C16.0624 16.8308 16.0667 16.8362 16.0711 16.8406C16.17 16.9395 16.3157 16.9993 16.456 16.9993C16.5897 16.9993 16.7484 16.9406 16.8408 16.8406C16.9354 16.7373 17.0061 16.6014 16.9996 16.4557C16.9931 16.3111 16.9441 16.1752 16.8408 16.0708C16.7615 15.9914 16.6821 15.9121 16.6017 15.8316C16.3853 15.6153 16.1679 15.3978 15.9515 15.1815C15.6319 14.8618 15.3133 14.5433 14.9937 14.2236C14.6044 13.8344 14.2152 13.4452 13.8249 13.0549C13.3976 12.6276 12.9693 12.1992 12.542 11.7719C12.1104 11.3403 11.6787 10.9087 11.246 10.476C10.8448 10.0748 10.4436 9.6736 10.0414 9.27132C9.70216 8.93211 9.36295 8.5929 9.02373 8.25369C8.77911 8.00906 8.53449 7.76444 8.28986 7.51981C8.17462 7.40457 8.05937 7.28824 7.94304 7.17299C7.9376 7.16864 7.93325 7.16321 7.9289 7.15886C7.82997 7.05992 7.68428 7.00012 7.54403 7.00012C7.4103 7.00012 7.25157 7.05883 7.15915 7.15886C7.06456 7.26214 6.99389 7.39804 7.00042 7.54373C7.00585 7.68833 7.05478 7.82423 7.15915 7.92861Z" fill="#878797"></path><path d="M16.0707 7.16013C15.9913 7.2395 15.9119 7.31886 15.8315 7.39932C15.6151 7.61567 15.3977 7.83312 15.1813 8.04947C14.8617 8.36912 14.5431 8.68767 14.2235 9.00732C13.8343 9.39654 13.445 9.78577 13.0547 10.1761C12.6275 10.6034 12.1991 11.0317 11.7718 11.459C11.3402 11.8906 10.9086 12.3222 10.4758 12.755C10.0747 13.1561 9.67347 13.5573 9.2712 13.9596C8.93199 14.2988 8.59278 14.638 8.25356 14.9772C8.00894 15.2219 7.76432 15.4665 7.51969 15.7111C7.40445 15.8264 7.28811 15.9416 7.17287 16.0579C7.16852 16.0634 7.16308 16.0677 7.15873 16.0721C7.0598 16.171 7 16.3167 7 16.4569C7 16.5907 7.05871 16.7494 7.15873 16.8418C7.26202 16.9364 7.39792 17.0071 7.54361 17.0006C7.68821 16.994 7.82411 16.9451 7.92849 16.8418C8.00785 16.7625 8.08722 16.6831 8.16767 16.6026C8.38403 16.3863 8.60148 16.1688 8.81783 15.9525C9.13747 15.6328 9.45603 15.3143 9.77567 14.9946C10.1649 14.6054 10.5541 14.2162 10.9444 13.8259C11.3717 13.3986 11.8001 12.9702 12.2274 12.543C12.659 12.1113 13.0906 11.6797 13.5233 11.247C13.9245 10.8458 14.3257 10.4446 14.728 10.0423C15.0672 9.70314 15.4064 9.36392 15.7456 9.02471C15.9902 8.78009 16.2348 8.53546 16.4795 8.29084C16.5947 8.17559 16.7111 8.06035 16.8263 7.94401C16.8306 7.93858 16.8361 7.93423 16.8404 7.92988C16.9394 7.83094 16.9992 7.68526 16.9992 7.545C16.9992 7.41128 16.9405 7.25254 16.8404 7.16013C16.7371 7.06554 16.6012 6.99487 16.4556 7.00139C16.311 7.00683 16.1751 7.05576 16.0707 7.16013Z" fill="#878797"></path></svg></button>    
            ${ props.title ? `<div class='form-step-controller-title-container'><h2>${props.title}</h2></div>` : '' }
            <div class="form-step-controller-form" data-form-step-controller-target="form"></div>
            <div class='form-step-controller-actions'>
                <button class='btn btn-primary' data-action='click->form-step-controller#nextStep' data-form-step-controller-target='action'>Next</button>
            </div>
        </div>
    `)

    if (append) {
        container.innerHTML += Dom(props);
    } else {
        container.innerHTML = Dom(props);
    }
}

export const ecommerce_platforms = [
    { label: 'Shopify', icon: BASE_URL + '/wp-content/themes/shipbob-2022/resources/images/logo-shopify.svg', value: 'Shopify' },
    { label: 'Amazon', icon: BASE_URL + '/wp-content/themes/shipbob-2022/resources/images/logo-amazon.svg', value: 'Amazon' },
    { label: 'WooCommerce', icon: BASE_URL + '/wp-content/themes/shipbob-2022/resources/images/logo-woocommerce.svg', value: 'WooCommerce' },
    { label: 'Magento', icon: BASE_URL + '/wp-content/themes/shipbob-2022/resources/images/logo-magento.svg', value: 'Magento' },
    { label: 'BigCommerce', icon: BASE_URL + '/wp-content/themes/shipbob-2022/resources/images/logo-bigcommerce.svg', value: 'BigCommerce' },
    { label: 'Salesforce', icon: BASE_URL + '/wp-content/themes/shipbob-2022/resources/images/logo-salesforce.svg', value: 'Salesforce' },
    { label: 'TikTok', icon: BASE_URL + '/wp-content/themes/shipbob-2022/resources/images/logo-tiktok.svg', value: 'TikTok' },
    { label: 'Walmart', icon: BASE_URL + '/wp-content/themes/shipbob-2022/resources/images/logo-walmart.svg', value: 'Walmart' },
    { label: 'Squarespace', icon: BASE_URL + '/wp-content/themes/shipbob-2022/resources/images/logo-squarespace.svg', value: 'Squarespace' },
    { label: 'Wix', icon: BASE_URL + '/wp-content/themes/shipbob-2022/resources/images/logo-wix.svg', value: 'Wix' },
    { label: 'NetSuite', icon: BASE_URL + '/wp-content/themes/shipbob-2022/resources/images/logo-netsuite.svg', value: 'NetSuite' },
    { label: 'None/Other', icon: BASE_URL + '/wp-content/themes/shipbob-2022/resources/images/icon-other.svg', value: 'None/Other' },
];

export const routing_options = [
    { label: 'Outsourced DTC fulfillment', icon: BASE_URL + '/wp-content/themes/shipbob-2022/resources/images/icon-oftrta-dtc.svg', value: 'DTC' },
    { label: 'Warehouse management software (U.S. only)', icon: BASE_URL + '/wp-content/themes/shipbob-2022/resources/images/icon-oftrta-wms.svg', value: 'WMS' },
];

export const ProductInterest = (controller = 'polysource-form', buttonTarget = 'nextButton', disabled = true) => {
    return `
        <div class='${controller}-step'>
            <h2 class="${controller}-step-heading">What type of fulfillment services are you interested in?</h2>
            <fieldset class='${controller}-option-fieldset'>
                <ul class='${controller}-option-grid'>${(routing_options.map(({ label, icon, value }, i) => {
                    return (`
                        <li class='${controller}-option-entry'>
                            <input type='radio' id='${value}' name='product_interest' value='${value}' data-${controller}-interest-param='${value}' data-action='click->${controller}#setInterest' ${ i == 0 ? 'checked' : '' } />
                            <label for='${value}'>
                                <div class='${controller}-option-entry-image interest'>
                                    <img src='${icon}' />
                                </div>
                                <p>${label}</p>
                            </label>
                        </li>
                    `)
                }).join(''))}</ul>
                <div class='${controller}-submit row justify-center'>
                    <button class='btn btn-primary' data-action='click->${controller}#next' data-${controller}-target='${buttonTarget}'  ${disabled ? 'disabled' : ''}>Next</button>
                </div>
            </fieldset>
        </div>
    `
}

export const EcommerceList = (controller = 'visual-form', buttonTarget = 'nextButton', disabled = true) => {
    return (
        `<div class='${controller}-step'>
            <h2 class="${controller}-step-heading">Which ecommerce platform do you use?</h2>
            <fieldset class='${controller}-option-fieldset'>
                <ul class='${controller}-option-grid'>${(ecommerce_platforms.map(({ label, icon, value }, i) => {
                    return (`
                        <li class='${controller}-option-entry'>
                            <input type='radio' id='${value}' name='ecommerce_provider' value='${value}' data-${controller}-provider-param='${value}' data-action='click->${controller}#setProvider' ${ i == 0 ? 'checked' : '' } />
                            <label for='${value}'>
                                <div class='${controller}-option-entry-image'>
                                    <img src='${icon}' />
                                </div>
                                <p>${label}</p>
                            </label>
                        </li>
                    `)
                }).join(''))}</ul>
                <div class="${controller}-show-more">
                    <div class="${controller}-show-more-cta" data-action='click->${controller}#showAllProviders'>
                        <p>See 8 more</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M13.3334 8.33334L10.0001 11.6667L6.66675 8.33334" stroke="#175CFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                    </div>
                </div>
                <div class='${controller}-submit row justify-center'>
                    <button class='btn btn-primary' data-action='click->${controller}#next' data-${controller}-target='${buttonTarget}' ${disabled ? 'disabled' : ''}>Next</button>
                </div>
            </fieldset>
        </div>`
    )
}

export const ShipmentsPerMonthSlide = (controller = 'visual-form', buttonTarget = 'nextButton') => {
    return (`
        <div class='${controller}-step'>
            <h2 class="${controller}-step-heading">How many shipments per month?</h2>
            <fieldset class='${controller}-spm-fieldset' data-${controller}-target='ranges'>
                <div class='${controller}-tooltip' data-${controller}-target='spmFeedback'></div>
                <div class='${controller}-range'>
                    <div class='${controller}-ticker'></div>
                    <input class='${controller}-spm-range' type="range" step="1" value="0" min="0" max="7" data-action='input->${controller}#shipmentsPerMonth touchmove->${controller}#shipmentsPerMonth'>
                </div>
                <div class="${controller}-spm-ranges">
                    <p>New Store / Not Shipping</p>
                    <p>50,000+</p>
                </div>
                <div class='${controller}-submit row justify-center'>
                    <button class='btn btn-primary' data-action='click->${controller}#next' data-${controller}-target='${buttonTarget}'>Next</button>
                </div>
            </fieldset>
        </div>
    `)
}